// Canadian EN/FR number typography for display text.
// English: "80%", "+2.3 points". French (OQLF): "80 %" with a non-breaking space, "+2,3 points",
// a non-breaking space before ":" and no space before ";", "?" or "!".

export const NBSP = " ";

// Appends a percent sign to an already formatted number.
export function withPercent(text, language) {
    if (text == null || text === "" || text === "—") return text ?? "—";
    return language === "fr" ? `${text}${NBSP}%` : `${text}%`;
}

// Signed change between two CVI values, in points (a CVI score is out of 100, not a percentage).
export function formatPointsChange(value, language, digits = 1) {
    const n = Number(value);
    if (value == null || !Number.isFinite(n)) return "—";
    const sign = Math.abs(n) < 0.5 * 10 ** -digits ? "±" : n > 0 ? "+" : "−";
    const text = new Intl.NumberFormat(language === "fr" ? "fr-CA" : "en-CA", { minimumFractionDigits: digits, maximumFractionDigits: digits }).format(Math.abs(n));
    return `${sign}${text} points`;
}

// Applied to French text produced by the legacy EN→FR page translator.
export function normalizeFrenchTypography(text) {
    if (text == null) return text;
    return String(text)
        .replace(/(\d)[   ]?%/g, `$1${NBSP}%`)
        .replace(/([\p{L})»’])[   ]?:(?=\s|$)/gu, `$1${NBSP}:`)
        .replace(/([\p{L}\p{N})»%])[   ]+([;!?])/gu, "$1$2");
}
